import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/web-app-dev/banner_web_app.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "10px" }}>
                Your Trusted Web Application {}
                <span style={{ color: "#F47a14" }}>Development Company</span>
              </h1>
              <p>
                Capitalize on our expertise in web programming, the commitment
                to agile project management, and awareness of tendencies to
                develop applications with increased ROI and exceptional user
                satisfaction. When you work with TekRevol as your web
                application development firm, success is not an option – it is
                inevitable.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get a Quote
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
